<template>
  <div
    class="effect-control-panel-toggle"
  >
    <lock-icon v-if="isLocked" />
    <unlock-icon v-else />
  </div>
</template>
<script setup lang="ts">
import LockIcon from '@/assets/LockWithCircleIcon.svg'
import UnlockIcon from '@/assets/UnlockIcon.svg'
import { toRefs } from 'vue'

const props = defineProps<{
  isLocked: boolean
}>()

const {
  isLocked
} = toRefs(props)

</script>
<style lang="scss">
.effect-control-panel-toggle {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background-color: $grey-80;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color 150ms $animationCurve;

  &:hover {
    background-color: $grey-60;
  }
}
</style>
